import * as React from "react";
import { LOADING, ActionSource } from "../../common/components/types";
import type { GlideFunctionalRenderer } from "../../common/components/uis";
import { LocationEntry } from "../chrome/smart/location-entry/location-entry";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useOnClickFromAction } from "hooks/use-on-click-from-action";
import { useEditComponentEnabledViaNetworkStatus } from "hooks/use-edit-components-enabled-via-network-status";
import { asBoolean, loadedDefinedMap } from "common/components/component-helpers";

export const LocationEntryMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[valuePV, onChangeValue, isEnabledValue, , isRequiredValue], [valueProducer, , , validFlagVP]] =
        useForceValueProducers(getValueProducers, force, ctx);
    const { onClick: onChange } = useOnClickFromAction(onChangeValue, ActionSource.ImagePicker, ctx, env);
    const [editingAllowed] = useEditComponentEnabledViaNetworkStatus(env);
    const isRequired = loadedDefinedMap(isRequiredValue, asBoolean) ?? false;

    const onClick = React.useCallback(
        async (newValue: string) => {
            if (valueProducer === undefined) return;

            valueProducer.set(newValue);
            await onChange?.(false);
        },
        [onChange, valueProducer]
    );

    if (valuePV === LOADING) {
        return env.renderProgress();
    }

    const isEnabled = editingAllowed && (onChange === undefined || isEnabledValue !== false);

    return (
        <LocationEntry
            setValue={onClick}
            validFlag={validFlagVP}
            disabled={!isEnabled}
            appID={env.appEnvironment.appID}
            required={isRequired}
            appKind={env.appEnvironment.appKind}
        />
    );
};
